import appColors from '@/styles/colors'
export default {
  computed: {
    appColors() {
      return appColors
    },
  },
}
